export default function UsdtIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="#26A17B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9609 8.69142V8.69042C8.9059 8.69442 8.6224 8.71142 7.9899 8.71142C7.4849 8.71142 7.1294 8.69642 7.0044 8.69042V8.69192C5.0604 8.60642 3.6094 8.26792 3.6094 7.86292C3.6094 7.45792 5.0604 7.11992 7.0044 7.03292V8.35492C7.1314 8.36392 7.4954 8.38542 7.9984 8.38542C8.6019 8.38542 8.9044 8.36042 8.9609 8.35542V7.03392C10.9009 7.12042 12.3484 7.45892 12.3484 7.86292C12.3484 8.26792 10.9009 8.60542 8.9609 8.69142ZM8.9609 6.89642V5.71342H11.6679V3.90942H4.2974V5.71342H7.0044V6.89592C4.8044 6.99692 3.1499 7.43292 3.1499 7.95492C3.1499 8.47692 4.8044 8.91242 7.0044 9.01392V12.8049H8.9609V9.01292C11.1574 8.91192 12.8079 8.47642 12.8079 7.95492C12.8079 7.43342 11.1574 6.99792 8.9609 6.89642Z"
        fill="white"
      />
    </svg>
  );
}
